class $51ab2c0018eca52b$var$Header {
    classes = {
        headerScrolledClass: 'header-scrolled',
        headerAbsoluteClass: 'header-absolute',
        heroArrowBlendClass: 'hero__arrow--blend',
        navListOpenClass: 'nav__list--open',
        xIcon: 'ph-x',
        listIcon: 'ph-list'
    };
    constructor(header){
        this.header = header;
        this.isDynamic = header.dataset.dynamic === 'true';
        this.heroArrow = header.querySelector('#heroArrow');
        this.mobileBtn = document.querySelector('#mobileBtn');
        this.mobileBtnIcon = document.querySelector('#mobileBtnIcon');
        this.navList = document.querySelector('#navList');
        this._init();
    }
    _init() {
        this.mobileBtn?.addEventListener('click', this._handleMobileBtn);
        if (this.isDynamic) window.onscroll = this._handleScroll;
        else this.header.classList.add(this.classes.headerScrolledClass);
    }
    _handleScroll = ()=>{
        const { headerAbsoluteClass: headerAbsoluteClass, headerScrolledClass: headerScrolledClass, heroArrowBlendClass: heroArrowBlendClass } = this.classes;
        if (window.scrollY > 0) {
            this.header.classList.add(headerScrolledClass);
            this.header.classList.remove(headerAbsoluteClass);
            this.heroArrow?.classList.add(heroArrowBlendClass);
        } else {
            this.header.classList.remove(headerScrolledClass);
            this.header.classList.add(headerAbsoluteClass);
            this.heroArrow?.classList.remove(heroArrowBlendClass);
        }
    };
    _handleMobileBtn = (e)=>{
        const { navListOpenClass: navListOpenClass, xIcon: xIcon, listIcon: listIcon } = this.classes;
        this.navList?.classList.toggle(navListOpenClass);
        const isMobileNavOpen = this.navList?.classList.contains(navListOpenClass);
        console.log(e.target);
        console.log(isMobileNavOpen);
        if (isMobileNavOpen) {
            const windowWith = window.innerWidth;
            const htmlWidth = document.documentElement.clientWidth;
            const scrollbarWidth = windowWith - htmlWidth;
            document.documentElement.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            this.mobileBtn.style.marginRight = `${scrollbarWidth}px`;
            this.mobileBtnIcon?.classList.replace(listIcon, xIcon);
        } else {
            this.mobileBtnIcon?.classList.replace(xIcon, listIcon);
            document.documentElement.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
            this.mobileBtn.style.marginRight = '0px';
        }
    };
}
var $51ab2c0018eca52b$export$2e2bcd8739ae039 = $51ab2c0018eca52b$var$Header;


class $e42b75aaa763af0b$export$2e2bcd8739ae039 {
    months = [
        "Stycze\u0144",
        'Luty',
        'Marzec',
        "Kwiece\u0144",
        'Maj',
        'Czerwiec',
        'Lipiec',
        "Sierpie\u0144",
        "Wrzesie\u0144",
        "Pa\u017Adziernik",
        'Listopad',
        "Grudzie\u0144"
    ];
    static dates = (...dates)=>dates.map((date)=>new Date(date));
    static date = (date)=>new Date(date);
    static getMonths = ()=>months;
    static from = (year, month, day = 1)=>new Date(year, month, day);
    static object = (date)=>{
        return {
            month: this.date(date).getMonth(),
            year: this.date(date).getFullYear(),
            day: this.date(date).getDate()
        };
    };
    static daysBetween(date1, date2) {
        const days = [];
        for(let day = new Date(date1); day <= date2; day.setDate(day.getDate() + 1))days.push(new Date(day));
        return days;
    }
    static isSameMonth = (date1, date2)=>{
        const { year: year1, month: month1 } = this.object(date1);
        const { year: year2, month: month2 } = this.object(date2);
        return year1 === year2 && month1 === month2;
    };
    static isSameDay = (date1, date2)=>{
        const { year: year1, month: month1, day: day1 } = this.object(date1);
        const { year: year2, month: month2, day: day2 } = this.object(date2);
        return year1 === year2 && month1 === month2 && day1 === day2;
    };
    static monthInputPattern = (year, month)=>`${String(year)}-${String(month + 1).padStart(2, '0')}`;
    static dateInputPattern = (date)=>{
        const { year: year, month: month, day: day } = this.object(date);
        const dayMarkup = String(day).padStart(2, '0');
        const monthMarkup = String(month + 1).padStart(2, '0');
        const yearMarkup = String(year);
        return `${yearMarkup}-${monthMarkup}-${dayMarkup}`;
    };
    static daysInMonth = (year, month)=>this.from(year, month + 1, 0).getDate();
    static prevMonth(year, month) {
        const prevYear = month === 0 ? year - 1 : year;
        const prevMonth = month === 0 ? 11 : month - 1;
        return {
            prevYear: prevYear,
            prevMonth: prevMonth
        };
    }
    static nextMonth(year, month) {
        const nextYear = month === 11 ? year + 1 : year;
        const nextMonth = month === 11 ? 0 : month + 1;
        return {
            nextYear: nextYear,
            nextMonth: nextMonth
        };
    }
    static nextYearDate = (date, increase = 1)=>new Date(date).setFullYear(date.getFullYear() + increase);
}


const $bd02c871d9c5ba8e$var$patternMDN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
function $bd02c871d9c5ba8e$export$18148d12c805c5b0(email) {
    return String(email).toLowerCase().match($bd02c871d9c5ba8e$var$patternMDN);
}
function $bd02c871d9c5ba8e$export$2d0e1952952b3a04() {
    const target = document.querySelector('[data-hero-scroll="true"]');
    target.scrollIntoView({
        block: 'center'
    });
}


class $d2247bac48b6a171$export$a7fed597f4b8afd8 {
    classes = {
        inputError: 'input__error',
        errorMessage: 'input__error-text--active'
    };
    inputsError = [];
    date = new Date();
    constructor(form, sendForm, handlers){
        this.form = form;
        this.sendForm = sendForm;
        this.handlers = handlers;
        this.selectApartment = form.querySelector('#selectApartment');
        this.startDateInput = form.querySelector('#startDate');
        this.endDateInput = form.querySelector('#endDate');
        this.emailInput = form.querySelector('#mail');
        this.messageInput = form.querySelector('#message');
        this.popup = document.querySelector('#popup');
        this.fnameInput = document.querySelector('#fname');
        this.lnameInput = document.querySelector('#lname');
        this.checkbox = document.querySelector('#politics');
        this.secondNameFake = document.querySelector('#secondName');
        this.fmessageFake = document.querySelector('#fmessage');
        this.inputs = [
            this.selectApartment,
            this.startDateInput,
            this.endDateInput,
            this.emailInput,
            this.messageInput,
            this.fnameInput,
            this.lnameInput
        ];
        this._setDateInputs(this.date, (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).nextYearDate(this.date, 2));
        this._addHandlers();
    }
    async _handleChangeSelectApartment(e) {
        e.target.disabled = true;
        this._resetDateInputs();
        const { changeCalendar: changeCalendar } = this.handlers;
        const apartmentId = e.target.value;
        if (apartmentId === 'start') {
            this._setDisabledDateInputs(true);
            return;
        } else this._setDisabledDateInputs(false);
        try {
            const data = await changeCalendar(apartmentId);
            e.target.disabled = false;
            if (data.currentDate) this.date = data.currentDate;
            this._setDateInputs(data.min, data.max);
        } catch (err) {
            e.target.disabled = false;
        }
    }
    async _handleFormSubmit(e) {
        e.preventDefault();
        this.resetErrors();
        const sendForm = this.sendForm;
        const form = this.form;
        try {
            await this._validate();
            await this.sendForm(this.form);
        } catch (err) {
            console.error(err);
        }
    }
    async _validate() {
        this._validateApartment();
        this._validateDates();
        this._validateEmail();
        this._validateEmpty(this.lnameInput);
        this._validateEmpty(this.fnameInput);
        this._validateEmpty(this.messageInput);
        this._validateCheckbox(this.checkbox);
        if (this.inputsError.length > 0) {
            this.inputsError[0].scrollIntoView({
                block: 'center'
            });
            throw new Error('wrong inputs');
        }
        // honeypot
        if (this.secondNameFake.value || this.fmessageFake.value) throw new Error('wrong inputs');
    }
    _validateCheckbox(checkbox) {
        if (!checkbox) return;
        if (!checkbox.checked) this._inputError('brak zaznaczenia', this.checkbox);
    }
    _validateDates() {
        if (!this.startDateInput || !this.endDateInput) return;
        if (!this.startDateInput.value || !this.endDateInput.value) this._inputError('Wybierz daty', this.startDateInput, this.endDateInput);
        const startDate = new Date(this.startDateInput.value);
        const endDate = new Date(this.endDateInput.value);
        const today = new Date(this.date).setDate(this.date.getDate() - 1);
        if (startDate < today) this._inputError("z\u0142a data przyjazdu", this.startDateInput);
        if (startDate > endDate) this._inputError("z\u0142y zakres dat", this.startDateInput, this.endDateInput);
        if (startDate.getDate() === endDate.getDate()) this._inputError("za kr\xf3tki okres", this.startDateInput, this.endDateInput);
    }
    _validateApartment() {
        const apartmentId = this.selectApartment.value;
        if (apartmentId === 'start') this._inputError('Wybierz Apartament', this.selectApartment);
    }
    _validateEmail() {
        const email = this.emailInput.value;
        const isValid = (0, $bd02c871d9c5ba8e$export$18148d12c805c5b0)(email);
        if (!isValid) this._inputError('Niepoprawny email', this.emailInput);
    }
    _validateEmpty(root) {
        if (root.value === '') this._inputError("Nie mo\u017Ce by\u0107 puste", root);
    }
    _inputError(message, ...roots) {
        roots.forEach((root)=>{
            this.inputsError.push(root);
            const { inputError: inputError, errorMessage: errorMessage } = this.classes;
            const errorField = root.parentElement.querySelector('#inputError');
            root.classList.add(inputError);
            if (errorField) {
                errorField.classList.add(errorMessage);
                errorField.innerText = message;
            }
        });
    }
    _resetInputError(root) {
        const { inputError: inputError, errorMessage: errorMessage } = this.classes;
        const errorField = root.parentElement.querySelector('#inputError');
        root.classList.remove(inputError);
        if (errorField) {
            errorField.classList.remove(errorMessage);
            errorField.innerText = "brak b\u0142\u0119du";
        }
    }
    resetErrors() {
        this.inputsError.forEach((input)=>this._resetInputError(input));
        this.inputsError = [];
    }
    resetInputs() {
        this.resetErrors();
        this.inputs.forEach((input)=>{
            input.value = '';
        });
    }
    _setDisabledDateInputs(state = true) {
        this.startDateInput.disabled = state;
        this.endDateInput.disabled = state;
    }
    _resetDateInputs() {
        this.startDateInput.value = null;
        this.endDateInput.value = null;
    }
    _setDateInputs(min, max) {
        this.startDateInput.min = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).dateInputPattern(min);
        this.endDateInput.min = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).dateInputPattern(min);
        this.startDateInput.max = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).dateInputPattern(max);
        this.endDateInput.max = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).dateInputPattern(max);
    }
    _addHandlers() {
        this.form.addEventListener('submit', this._handleFormSubmit.bind(this));
        this.selectApartment?.addEventListener('change', this._handleChangeSelectApartment.bind(this));
    }
    loading() {
        this.popup.classList.add('popup--visible');
        this.popup.innerHTML = `
		<div class="popup__container">
		<i class="ph ph-circle-notch popup__loading-icon"></i>
		<p>wysy\u{142}anie</p>
	</div>
		`;
    }
    confirmSend() {
        this.popup.classList.add('popup--visible');
        this.popup.innerHTML = `
		<div class="popup__container">
		<i class="ph ph-check popup__confirm-icon"></i>
		<p>Wiadomo\u{15B}\u{107} wys\u{142}ano pomy\u{15B}lnie</p>
		<button class="popup__confirm-btn" id="popupBtn">OK</button>
	</div>
		`;
        this._listenToClosePopup();
    }
    _listenToClosePopup() {
        const btn = this.popup.querySelector('#popupBtn');
        btn.addEventListener('click', this._hidePopup);
    }
    _hidePopup = ()=>this.popup.classList.remove('popup--visible');
    alertSendError() {
        this.popup.classList.add('popup--visible');
        this.popup.innerHTML = `
		<div class="popup__container">
		<i class="ph ph-x popup__error-icon"></i>
		<p><span class="popup__error-span">Wysy\u{142}anie nie powiod\u{142}o si\u{119}.</span> Spr\xf3buj ponownie lub napisz na email</p>
		<button class="popup__error-btn" id="popupBtn">OK</button>
		</div>
		`;
        this._listenToClosePopup();
    }
}



class $190f6a0b6d832286$export$e1aef45b828286de {
    root;
    min;
    max;
    messages = {
        initMsg: 'Wybierz apartament',
        loadMsg: 'Trwa pobieranie danych...',
        errMsg: "Co\u015B posz\u0142o nie tak \uD83D\uDE1F",
        errBtnMsg: "Spr\xf3buj ponownie"
    };
    displayed = {
        date: null,
        year: null,
        month: null
    };
    constructor(root){
        this.root = root;
        this.permanent = root.dataset.apartment ? true : false;
        this.id = root.dataset.apartment;
        this._init();
    }
    isPermanent = ()=>this.permanent;
    getApartmentId = ()=>this.id;
    displayData({ getDaysData: getDaysData, currDate: currDate, min: min, max: max }) {
        this.root.innerHTML = this._calendarMarkup();
        this._addHandlers();
        this.getDaysData = getDaysData;
        this._setMinMax(min, max);
        const { year: year, month: month } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).object(currDate);
        this._updateView(year, month);
    }
    _updateView(year, month) {
        this._setDisplayed(year, month);
        this._setMonthInputValue(year, month);
        const days = this.getDaysData(year, month);
        this.root.querySelector('#days').innerHTML = this._daysMarkup(days);
    }
    _setMinMax(min, max) {
        this.max = max;
        this.min = min;
        this._setMonthInputMinMax(min, max);
    }
    _setDisplayed(year, month) {
        this.displayed.month = month;
        this.displayed.year = year;
        this.displayed.date = new Date(year, month, 1);
    }
    _setMonthInputMinMax(min, max) {
        const monthContainer = this.root.querySelector('#displayedMonth');
        const { year: minYear, month: minMonth } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).object(min);
        const { year: maxYear, month: maxMonth } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).object(max);
        monthContainer.min = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).monthInputPattern(minYear, minMonth);
        monthContainer.max = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).monthInputPattern(maxYear, maxMonth);
    }
    _setMonthInputValue(year, month) {
        const monthContainer = this.root.querySelector('#displayedMonth');
        monthContainer.value = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).monthInputPattern(year, month);
    }
    _handleLeftArrowClick = (e)=>{
        e.preventDefault();
        const { date: date, month: month, year: year } = this.displayed;
        if ((0, $e42b75aaa763af0b$export$2e2bcd8739ae039).isSameMonth(date, this.min)) return;
        const { prevYear: prevYear, prevMonth: prevMonth } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).prevMonth(year, month);
        this._updateView(prevYear, prevMonth);
    };
    _handleRightArrowClick = (e)=>{
        e.preventDefault();
        const { month: month, year: year, date: date } = this.displayed;
        if ((0, $e42b75aaa763af0b$export$2e2bcd8739ae039).isSameMonth(date, this.max)) return;
        const { nextYear: nextYear, nextMonth: nextMonth } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).nextMonth(year, month);
        this._updateView(nextYear, nextMonth);
    };
    _handleInputChange = (e)=>{
        e.preventDefault();
        const [year, month] = e.target.value.split('-');
        const date = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).from(year, month);
        if (date > this.max || date < this.min) return;
        this._updateView(+year, +month - 1);
    };
    _handleInputBlur = (e)=>{
        e.preventDefault();
        const [year, month] = e.target.value.split('-');
        const date = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).from(year, month);
        const { year: minYear, month: minMonth } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).object(this.min);
        const { year: maxYear, month: maxMonth } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).object(this.max);
        if (date > this.max) this._updateView(maxYear, maxMonth);
        if (date < this.min) this._updateView(minYear, minMonth);
    };
    _addHandlers() {
        const arrowLeft = this.root.querySelector('#arrowLeft');
        const arrowRight = this.root.querySelector('#arrowRight');
        const monthInput = this.root.querySelector('#displayedMonth');
        monthInput?.addEventListener('blur', this._handleInputBlur);
        monthInput?.addEventListener('change', this._handleInputChange);
        arrowLeft?.addEventListener('click', this._handleLeftArrowClick);
        arrowRight?.addEventListener('click', this._handleRightArrowClick);
    }
    error() {
        this.root.innerHTML = `
		<div class="calendar__error">
			<p>${this.messages.errMsg}</p>
			<button class="calendar__error-btn" id="errorBtn">
			${this.messages.errBtnMsg}
			</button>
		</div>
		`;
        const errorBtn = this.root.querySelector('#errorBtn');
        return errorBtn;
    }
    setLoading() {
        this.root.innerHTML = `
		<div class="calendar__loading">
		<i class="ph ph-circle-notch"></i>
		<p>${this.messages.loadMsg}</p>
		</div>
		`;
    }
    _init() {
        this.root.innerHTML = `
		<div class="calendar__init">
		<p>${this.messages.initMsg}</p>
		</div>`;
    }
    _calendarMarkup() {
        const markup = `
		<div class="calendar__top">
		  <button class="calendar__top-arrows-item calendar__top-arrows-item-left" id="arrowLeft" aria-label="poprzedni miesi\u{105}c" tabindex="-1">
        <i class="ph ph-arrow-circle-left"></i>
      </button>
	  	<input type="month" class="calendar__top-date"  id="displayedMonth" aria-label="wybierz miesi\u{105}c" tabindex="-1"></input>
			<button class="calendar__top-arrows-item calendar__top-arrows-item-right" id="arrowRight" aria-label="nast\u{119}pny miesi\u{105}c" tabindex="-1">
        <i class="ph ph-arrow-circle-right"></i>
      </button>
		</div>
	  <div class="calendar__box">
	    <div class="calendar__week-days">
	      <span class="calendar__week-days-item">pon.</span>
	      <span class="calendar__week-days-item">wt.</span>
	      <span class="calendar__week-days-item">\u{15B}r.</span>
	      <span class="calendar__week-days-item">czw.</span>
	      <span class="calendar__week-days-item">pt.</span>
	      <span class="calendar__week-days-item">sob.</span>
	      <span class="calendar__week-days-item">nd.</span>
	    </div>
	    <div class="calendar__days" id="days">
	    </div>
	  </div>
	  `;
        return markup;
    }
    _daysMarkup(days) {
        let markup = '';
        if (!days) return;
        const firstDay = days[0];
        const firstWeekDay = firstDay.date.getDay() === 0 ? 7 : firstDay.date.getDay();
        for(let i = 1; i < firstWeekDay; i++)markup += ` <div class="calendar__days-item">
        <span class="calendar__days-item-day"></span>
      </div>`;
        days.forEach((day)=>{
            const dayMarkup = ` <div class="calendar__days-item ${day.occupied ? 'calendar__days-item--occupied' : 'calendar__days-item--available'}">
        <span class="calendar__days-item-day">${day.date.getDate()}</span>
        </div>`;
            markup += dayMarkup;
        });
        return markup;
    }
}


class $d529ab21baf1a41a$export$472062a354075cee {
    touch = {
        swipeThreshold: 50,
        translate: 0,
        start: {
            x: null,
            y: null
        },
        delta: {
            min: 70,
            x: null,
            y: null
        }
    };
    classes = {
        activeDot: `slider__dots-dot--active`
    };
    constructor(root, itemsNum, photoClass, autoInit = false){
        this.root = root;
        this.photoClass = photoClass || 'slider__item';
        this.itemsNum = +itemsNum || 1;
        this.active = 1;
        this.root.innerHTML = this._sliderMarkup();
        this.sliderContainer = this.root.querySelector('#sliderContainer');
        this.dotsContainer = this.root.querySelector('#sliderDots');
        this.btnLeft = this.root.querySelector('#sliderBtnLeft');
        this.btnRight = this.root.querySelector('#sliderBtnRight');
        if (autoInit) this.init();
    }
    init() {
        this._addHandlers();
        this.setActiveImage(this.active);
    }
    setActiveImage(id) {
        this.active = +id;
        this._setActiveDot(id);
        const itemLengthInPrecents = 100 / this.itemsNum;
        const translate = -(id - 1) * itemLengthInPrecents + '%';
        this.sliderContainer.style.transform = `translateX(${translate})`;
    }
    _setActiveDot(id) {
        const { activeDot: activeDot } = this.classes;
        this.dotsContainer.querySelectorAll(`.${activeDot}`).forEach((dot)=>dot.classList.remove(activeDot));
        this.dotsContainer.querySelector(`[data-image-id="${id}"]`).classList.add(activeDot);
    }
    _createDots() {
        let markup = '';
        for(let i = 0; i < this.itemsNum; i++)markup += `<button class="slider__dots-dot" id="dot" data-image-id="${i + 1}" aria-label="zdj\u{119}cie nr ${i + 1}"></button>`;
        return markup;
    }
    _createImages() {
        let markup = '';
        for(let i = 0; i < this.itemsNum; i++)markup += `<div class="slider__item ${this.photoClass}--${i + 1}" id="sliderItem"><div class="slider__item-img"></div></div>`;
        return markup;
    }
    _sliderMarkup() {
        return `
		<div class="slider__box">
			<div class="slider__btns">
				<button class="slider__btns-btn slider__btns-btn-left" id="sliderBtnLeft" aria-label="poprzednie zdj\u{119}cie"><i class="ph ph-caret-left"></i></button>
				<button class="slider__btns-btn slider__btns-btn-right" id="sliderBtnRight" aria-label="nast\u{119}pne zdj\u{119}cie"><i class="ph ph-caret-right"></i></button>
				</div>
				<div class="slider__container" id="sliderContainer">
				${this._createImages()}
				</div>
				</div>
				<div class="slider__dots" id="sliderDots">
					${this._createDots()}
				</div>`;
    }
    _addHandlers() {
        this.btnLeft.addEventListener('click', this._handleLeftArrowClick);
        this.btnRight.addEventListener('click', this._handleRightArrowClick);
        this.dotsContainer.querySelectorAll('#dot').forEach((dot)=>dot.addEventListener('click', this._handleDotClick));
        this.sliderContainer.addEventListener('touchstart', this.handleTouchSart);
        this.sliderContainer.addEventListener('touchmove', this.handleTouchMove);
        this.sliderContainer.addEventListener('touchend', this.handleTouchEnd);
    }
    _handleLeftArrowClick = (e)=>{
        e.preventDefault();
        if (!this.active) return;
        if (this.active === 1) this.setActiveImage(this.active);
        else this.setActiveImage(this.active - 1);
    };
    _handleRightArrowClick = (e)=>{
        e.preventDefault();
        if (!this.active) return;
        if (this.active === this.itemsNum) this.setActiveImage(this.active);
        else this.setActiveImage(this.active + 1);
    };
    _handleDotClick = (e)=>{
        e.preventDefault();
        this.setActiveImage(e.target.closest('#dot').dataset.imageId);
    };
    handleTouchSart = (e)=>{
        const firstTouch = e.touches[0];
        this.touch.start.x = firstTouch.clientX;
        this.touch.start.y = firstTouch.clientY;
    };
    handleTouchMove = (e)=>{
        //* UPDATE TOUCH STATE
        const { start: start } = this.touch;
        // Ensure the touch start values exist
        if (start.x === null || start.y === null) return;
        // Get the current touch position
        const curr = e.touches[0];
        // Calculate horizontal movement
        this.touch.delta.x = curr.clientX - start.x;
        // Calculate vertical movement
        this.touch.delta.y = curr.clientY - start.y;
        if (Math.abs(this.touch.delta.y) > Math.abs(this.touch.delta.x)) return;
        else e.preventDefault();
        //* CALCULATE TRANSLATE
        // Determine the item length in percentages
        const itemLengthInPercent = 100 / this.itemsNum;
        // Calculate new translate value in pixels
        const sliderWidth = this.sliderContainer.offsetWidth;
        // Convert px to %
        const deltaXInPercent = this.touch.delta.x / sliderWidth * 100;
        // Calculate the updated translate position
        const translate = -(this.active - 1) * itemLengthInPercent + deltaXInPercent;
        // Save the current translate position for further calculations
        this.touch.translate = translate;
        //* UPDATE TRANSFORM STYLE
        this.sliderContainer.style.transition = 'none';
        this.sliderContainer.style.transform = `translateX(${translate}%)`;
    };
    handleTouchEnd = (e)=>{
        const { delta: delta, swipeThreshold: threshold } = this.touch;
        this.sliderContainer.style.transition = '';
        if (delta.x > threshold) this._handleLeftArrowClick(e);
        else if (delta.x < -threshold) this._handleRightArrowClick(e);
        else this.setActiveImage(this.active);
        this._resetTouch();
    };
    _resetTouch() {
        this.touch = {
            ...this.touch,
            translate: 0,
            start: {
                ...this.touch.start,
                x: null,
                y: null
            },
            delta: {
                ...this.touch.delta,
                x: null,
                y: null
            }
        };
    }
}


class $70f5f1aa138674e7$export$41246775a7cbd85b extends (0, $d529ab21baf1a41a$export$472062a354075cee) {
    classes = {
        ...this.classes,
        sliderOpened: 'room__slider--opened'
    };
    constructor(root){
        const slider = root.querySelector('#slider');
        super(slider, slider.dataset.imagesNum, slider.dataset.itemClass);
        this.root = root;
        this.roomBtn = this.root.querySelector('#closeSliderBtn');
        this.isOpened = this.root.classList.contains(this.classes.sliderOpened);
        this.photos = document.querySelectorAll('#photosImg');
        this.photosItems = document.querySelectorAll('#photosItem');
        this.init();
    }
    _addHandlers() {
        super._addHandlers();
        this.roomBtn.addEventListener('click', this._handleRoomBtnClick);
        this.photosItems.forEach((photo)=>photo.addEventListener('click', this._handlePhotoClick));
    }
    _openRoomSlider() {
        document.documentElement.style.overflow = 'hidden';
        this.root.classList.add(this.classes.sliderOpened);
        document.addEventListener('click', this._handleOutsideClick);
    }
    _handleOutsideClick = (e)=>{
        if (e.target.closest('#slider')) return;
        this._closeRoomSlider();
        document.removeEventListener('click', this.boundHandleOutsideClick);
    };
    _closeRoomSlider() {
        document.documentElement.style.overflow = 'auto';
        this.root.classList.remove(this.classes.sliderOpened);
    }
    _handlePhotoClick = (e)=>{
        e.stopPropagation();
        const id = e.target.closest('#photosItem').querySelector('#photosImg').dataset.imgNum;
        if (this.isOpened) this._closeRoomSlider();
        else this._openRoomSlider();
        this.setActiveImage(+id);
    };
    _handleRoomBtnClick = ()=>{
        const { sliderOpened: sliderOpened } = this.classes;
        if (this.isOpened) this.root.classList.add(sliderOpened);
        else this.root.classList.remove(sliderOpened);
    };
}



class $fa81208e0a0a8f4a$export$144901db2ea8e967 extends (0, $d529ab21baf1a41a$export$472062a354075cee) {
    constructor(root, itemsNum, photoClass){
        super(root, itemsNum, photoClass);
        this.init();
    }
}



const $02ae9d3e421b603d$var$WORKER = 'terminy.krynica-serwis.workers.dev';
const $02ae9d3e421b603d$var$URL = `https://${$02ae9d3e421b603d$var$WORKER}/`;
async function $02ae9d3e421b603d$export$dd001e732abd1fa3(id) {
    try {
        const apartmentName = encodeURIComponent(id);
        const res = await fetch(`${$02ae9d3e421b603d$var$URL}?apartmentName=${apartmentName}`);
        const apiData = await res.json();
        const { status: status, message: message, data: data } = apiData;
        if (status === 'error') throw new Error(message);
        return data;
    } catch (err) {
        console.error('googleSheetsApi: ', err);
    }
}



class $31cb520747c0153c$export$a1edc412be3e1841 {
    dates;
    currentDate;
    static initForm = ()=>{
        (function() {
            emailjs.init({
                publicKey: 'WDbrRG7RHZmUHMFuo'
            });
        })();
    };
    static getCurrDate = ()=>this.currentDate;
    static sendForm = async (form)=>{
        try {
            await emailjs.sendForm('service_no5cdcq', 'template_z9fsh63', form);
        } catch (error) {
            throw new Error(error.message);
        }
    };
    static getCalendarData = async (id)=>{
        try {
            const data = await Promise.race([
                (0, $02ae9d3e421b603d$export$dd001e732abd1fa3)(id),
                this._waitForData(60)
            ]);
            this.data = data;
            this.currentDate = new Date(data.currentDate);
            return {
                getDaysData: this.getDays,
                currDate: this.currentDate,
                min: this.currentDate,
                max: this.data.maxDate
            };
        } catch (err) {
            throw new Error(err.message);
        }
    };
    static _waitForData = async (time)=>{
        const timeoutPromise = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new Error('Fetching data timed out'));
            }, time * 1000);
        });
        return timeoutPromise;
    };
    static _getOccupiedDays = (year, month)=>{
        const days = this.data.dates.map((date)=>new Date(date)).filter((date)=>(0, $e42b75aaa763af0b$export$2e2bcd8739ae039).isSameMonth(date, (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).from(year, month)));
        return days;
    };
    static getDays = (year, month)=>{
        const occupiedDays = this._getOccupiedDays(year, month);
        const daysInMonth = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).daysInMonth(year, month);
        const occupiedDaysSet = new Set(occupiedDays ? occupiedDays.map((day)=>day.getDate()) : []);
        let days = [];
        for(let i = 1; i <= daysInMonth; i++){
            const date = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).from(year, month, i);
            let isOccupied = occupiedDaysSet.has(i);
            const { year: currYear, month: currMonth, day: currDay } = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).object(this.currentDate);
            const yesterday = (0, $e42b75aaa763af0b$export$2e2bcd8739ae039).from(currYear, currMonth, currDay);
            if (date < yesterday) isOccupied = true;
            days.push({
                date: date,
                occupied: isOccupied
            });
        }
        return days;
    };
}


function $b464e8376c58de0c$export$b08464e47b7a3a8(mapRoot) {
    const { lon: lon, lat: lat, zoom: zoom } = mapRoot.dataset;
    var map = L.map('map').setView([
        lat,
        lon
    ], zoom);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
    var marker = L.marker([
        lat,
        lon
    ]).addTo(map);
}


class $58789f4cd33c3418$export$bd0bf19f25da8474 {
    constructor(){
        this.headerRoot = document.querySelector('#header');
        this.formRoot = document.querySelector('#form');
        this.footerDateSpan = document.querySelector('#footerDate');
        this.calendarRoot = document.querySelector('#calendar');
        this.carouselRoot = document.querySelector('#carousel');
        this.roomSliderRoot = document.querySelector('#roomSlider');
        this.photos = document.querySelectorAll('#photosImg');
        this.heroArrow = document.querySelector('#heroArrow');
        this.map = document.querySelector('#map');
        this._init();
    }
    _init() {
        if (this.firstScrolls) this._initAppearOnLoadScroll(this.firstScrolls);
        if (this.headerRoot) this._initHeader(this.headerRoot);
        if (this.footerDateSpan) this._initFooter(this.footerDateSpan);
        if (this.calendarRoot) this._initCalendar(this.calendarRoot);
        if (this.formRoot) this._initForm(this.formRoot);
        if (this.roomSliderRoot) this._initRoomSlider(this.roomSliderRoot);
        if (this.carouselRoot) this._initCarousel(this.carouselRoot);
        if (this.heroArrow) this._initHeroArrow(this.heroArrow);
        if (this.map) (0, $b464e8376c58de0c$export$b08464e47b7a3a8)(this.map);
    }
    _initHeader = (root)=>new (0, $51ab2c0018eca52b$export$2e2bcd8739ae039)(root);
    _initCarousel = (root)=>new (0, $fa81208e0a0a8f4a$export$144901db2ea8e967)(root, 4, 'carousel');
    _initRoomSlider = (root)=>new (0, $70f5f1aa138674e7$export$41246775a7cbd85b)(root);
    _initHeroArrow(root) {
        root.addEventListener('click', (0, $bd02c871d9c5ba8e$export$2d0e1952952b3a04));
    }
    _initFooter(root) {
        const currYear = new Date().getFullYear();
        root.innerHTML = currYear;
    }
    _initCalendar(root) {
        this.Calendar = new (0, $190f6a0b6d832286$export$e1aef45b828286de)(root);
        if (!this.Calendar.isPermanent()) return;
        this.setCalendarData(this.Calendar.getApartmentId());
    }
    _initForm(root) {
        (0, $31cb520747c0153c$export$a1edc412be3e1841).initForm();
        this.Form = new (0, $d2247bac48b6a171$export$a7fed597f4b8afd8)(root, this.handleSendForm, {
            changeCalendar: this.setCalendarData,
            calcBookingRange: this.calcBookingRange
        });
    }
    handleSendForm = async (form)=>{
        this.Form.resetErrors();
        this.Form.loading();
        try {
            await (0, $31cb520747c0153c$export$a1edc412be3e1841).sendForm(form);
            this.Form.confirmSend();
        } catch (err) {
            this.Form.alertSendError();
        }
    };
    setCalendarData = async (id)=>{
        if (!this.Calendar) return;
        this.Calendar.setLoading();
        try {
            const data = await (0, $31cb520747c0153c$export$a1edc412be3e1841).getCalendarData(id);
            this.Calendar.displayData(data);
            return data;
        } catch (err) {
            console.error(err);
            const errorBtn = this.Calendar.error(err);
            errorBtn.addEventListener('click', ()=>this.setCalendarData(id));
        }
    };
}


document.addEventListener('DOMContentLoaded', $54b47fc030b7b21e$var$main);
async function $54b47fc030b7b21e$var$main() {
    new (0, $58789f4cd33c3418$export$bd0bf19f25da8474)();
}


//# sourceMappingURL=repo.ccbfcf3a.js.map
